import { useItemFunctionMenuItemsType } from '../../../../../Utils/ObjektVyUtils';
import { useOppnaBetalning } from './Funktioner/useÖppnaBetalning';
import { useSparraBetalning } from './Funktioner/useSparraBetalning';

export const useBetalningFunktionsMenyItems: useItemFunctionMenuItemsType =
  input => {
    const { mutate: öppnaBetalning, disabled: öppnaBetalningDisabled } =
      useOppnaBetalning(input);
    const { mutate: spärraBetalning, disabled: spärraBetalningDisabled } =
      useSparraBetalning(input);

    return [
      {
        id: 'Spärra betalning',
        caption: 'Spärra betalning',
        onClick: spärraBetalning,
        disabled: spärraBetalningDisabled,
        disabledReason: 'Funktionen spärrad',
      },
      {
        id: 'Öppna för betalning',
        caption: 'Öppna för betalning',
        onClick: öppnaBetalning,
        disabled: öppnaBetalningDisabled,
        disabledReason: 'Funktionen spärrad',
      },
      {
        id: 'Ta bort från utbetalningsorder',
        caption: 'Ta bort från utbetalningsorder',
        disabled: true,
        disabledReason: 'Denna funktion är ej skapad ännu',
      },
      {
        id: 'Ändra betalningsdatum',
        caption: 'Ändra betalningsdatum',
        disabled: true,
        disabledReason: 'Denna funktion är ej skapad ännu',
      },
      {
        id: 'Ändra planerade betalningar',
        caption: 'Ändra planerade betalningar',
        disabled: true,
        disabledReason: 'Denna funktion är ej skapad ännu',
      },
      {
        id: 'Bokför utbetalningsuppdrag',
        caption: 'Bokför utbetalningsuppdrag',
        disabled: true,
        disabledReason: 'Denna funktion är ej skapad ännu',
      },
    ];
  };
